import { IVerificationStatus } from '~/@api/generated-api-types-user/Api'
import { useUser } from '~/@biz_account/useUser/useUser'
import { IdentityVerificationDeclined } from '../dialog-and-results/IdentityVerificationDeclined'
import { IdentityVerificationSubmitted } from '../dialog-and-results/IdentityVerificationSubmitted'
import { IdentityVerification } from './IdentityVerification'
import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'

function IdentityVerificationContent() {
  const { user } = useUser()

  const verificationStatus = (() => {
    const status =
      user != null && user.profile.identity
        ? user.profile.identity.verificationStatus
        : null
    if (status === 'started') {
      return null
    }
    return status || null
  })()

  const content = (() => {
    if (
      [
        IVerificationStatus.Declined,
        IVerificationStatus.ResubmissionRequested,
      ].includes(verificationStatus as IVerificationStatus)
    ) {
      return <IdentityVerificationDeclined />
    }

    if (verificationStatus === IVerificationStatus.Submitted) {
      return <IdentityVerificationSubmitted />
    }

    // `underage` (Veriff approved, ale pod 18) padá sem: formulár ostáva, Veriff sa neotvorí,
    // modal vysvetlí prečo — BE `isUnderage` sa v deň 18. narodenín prepne na false.
    // `expired_id` (doklad expiroval) padá sem tiež: bežný formulár, user ide na Veriff znova.
    // `reverification_mismatch` (nový doklad nesedí s účtom): formulár + modal „Skúsiť znova“.
    return (
      <IdentityVerification
        callbackDoVeriff={() => {}}
        isUnderage={user?.profile.identity?.isUnderage === true}
        isReverificationMismatch={
          verificationStatus === IVerificationStatus.ReverificationMismatch
        }
      />
    )
  })()

  return (
    <>
      <div className="flex justify-start">
        <BackButton>Späť</BackButton>
      </div>
      {content}
    </>
  )
}

export { IdentityVerificationContent }
